<template src="./templates/index.html" />
<script type="text/ecmascript-6">
import { mapGetters } from 'vuex'
import FouSelect from 'components/form/fou-select/'
import { FouSelectObject } from 'src/utils/objects/fou-select'
import AnimationProcessing from 'components/animations/processing'
import Misc from 'src/utils/helper/misc'
import { getFoundrySubTitle, attemptFoundrySwitch } from 'src/utils/helper/contractTermination'
import {isEqual} from 'lodash'

export default {
  name: 'foundry-dropdown-dashboard',

  data () {
    return {
      foundry: FouSelectObject(),
      foundryLoaded: false,
      permissionsFoundryList: [],
      updatedsessionFoundryId: '',
      updatedsessionFoundryName: ''
    }
  },

  components: {
    FouSelect,
    AnimationProcessing
  },

  props: {
    inputWidth: {
      type: String,
      default: ''
    },
    from: {
      type: String,
      default: ''
    },
    isLabelRequired: {
      type: Boolean,
      default: true
    },
    isAllFoundriesOption: {
      type: Boolean,
      default: false
    },
    getSelectedFoundry: {
      type: Function,
      default: () => {}
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    ...Misc,
    setFoundryOptions () {
      const enriched = this.permissionsFoundryList.map(f => ({
        ...f,
        subTitle: getFoundrySubTitle(f.contractStatus)
      }))
      this.foundry.setOptions({
        obj: enriched,
        value: 'id',
        name: 'name',
        multiple: true
      })
      this.foundryLoaded = true
    },
    getUsersAsPerFoundry (defaultFoundryId) {
      this.$store.dispatch('profile/getUsersAsPerFoundryDropDown', defaultFoundryId)
    },
    updateFoundryValues (val) {
      if (this.foundryLoaded) {
        if (val) {
          if (!isEqual(val.value, '-1')) {
            if (attemptFoundrySwitch({
              foundryId: val.value,
              isUserAdmin: this.$store.getters['auth/isUserAdmin'],
              store: this.$store,
              revertSelection: () => {
                this.$nextTick(() => {
                  const prevId = window.localStorage.getItem('sessionFoundryId')
                  const prevName = window.localStorage.getItem('sessionFoundryName')
                  this.getSetFoundryLabel(prevId, prevName)
                })
              }
            })) return
            this.foundry.state = 'set'
            this.getSelectedFoundry(val)
            this.foundry.update(val, this.updateSessionFoundry(val.value, val.label))
          }
        } else {
          let objVal = { label: window.localStorage.getItem('sessionFoundryName'), value: window.localStorage.getItem('sessionFoundryId') }
          this.foundry.setValues({
            obj: objVal,
            value: 'value',
            name: 'label'
          })
        }
      }
      // else {
      //   this.foundry.update(val, this.updateSessionFoundry(val.value, val.label))
      // }
      this.foundryLoaded = true
    },
    getSetFoundryLabel (fId, fName) {
      if (fId && fName) {
        let val = { label: fName, value: fId }
        this.foundry.setValues({
          obj: val,
          value: 'value',
          name: 'label'
        })
      }
    },
    updateSessionFoundry (sessionFoundryId, sessionFoundryName) {
      this.$store.dispatch('auth/setSessionFoundry', {'id': sessionFoundryId, 'name': sessionFoundryName})
      .then(() => {
        this.$store.commit('profile/setFoundrySessionName')
        this.$store.commit('profile/setFoundrySessionId')
        let objVal = { label: window.localStorage.getItem('sessionFoundryName'), value: window.localStorage.getItem('sessionFoundryId') }
        this.foundry.setValues({
          obj: objVal,
          value: 'value',
          name: 'label'
        })
        if (this.$route.name === 'home') {
          this.$events.$emit('get_submissions', true)
        }
        if (this.$route.name === 'promos') {
          this.$events.$emit('get_promotions')
        }
        if (this.$route.name === 'user_permissions') {
          this.getUsersAsPerFoundry(sessionFoundryId)
        }
        Misc.setDataLayerObj()
      })
    },
    setDefaultFoundry (defaultFoundry) {
      return this.$store.dispatch('profile/setDefaultfoundry', defaultFoundry)
    },
    setDdLabel () {
      this.foundryLoaded = false
      this.getSetFoundryLabel(this.defaultFoundry.id, this.defaultFoundry.name)
    },
    filterPermittedFoundries (foundries, from) {
      const foundriesArray = []
      foundries.forEach((foundry) => {
        const permissionArray = []
        foundry.permissions.forEach((item) => permissionArray.push(item.name))
        if (permissionArray.includes(from)) {
          foundriesArray.push(foundry)
        }
      })
      return foundriesArray
    }
  },

  created () {
    if (this.getUserRoles(this.user) !== 'foundrySupport') {
      this.$store.dispatch('profile/getFoundries', this.from).then(() => {
        this.permissionsFoundryList = Misc.isValidValue(this.from) ? this.filterPermittedFoundries(this.foundries, this.from) : this.foundries
        this.setFoundryOptions()
        window.localStorage.setItem('permissionsArr', JSON.stringify(Misc.getPermissionsArr(this.foundries)))
        this.$store.dispatch('auth/setPermissionsArr', Misc.getPermissionsArr(this.foundries))
        if (this.foundries.length === 0) {
          this.$router.replace({ name: 'contract' })
        }
        const isSessFoundry = this.foundries.some((data) => data.name === this.sessionFoundryName)
        if (Array.isArray(this.defaultFoundry) && this.defaultFoundry.length === 0 && isSessFoundry) {
          this.setDefaultFoundry(this.foundries[0])
        }
        if (Array.isArray(this.defaultFoundry) && this.defaultFoundry.length === 0 && !isSessFoundry) {
          this.setDefaultFoundry(this.foundries[0]).then(() => {
            this.setDdLabel()
          })
        }
        let sessionId = window.localStorage.getItem('sessionFoundryId')
        let foundry = this.setFoundryForModuleOnNavigation(this.defaultFoundry, this.foundries, this.getRouteTabName(), sessionId)
        setTimeout(() => {
          this.emitFunctionsbasedonRoute()
          this.getSetFoundryLabel(
            foundry.foundryId,
            foundry.foundryName
          )
        }, 1000)
      })
    }
  },

  computed: {
    ...mapGetters('auth', ['user', 'hasRole', 'getPermissionsArr', 'sessionFoundryName', 'sessionFoundryId']),
    ...mapGetters('contract', ['isUFDAFlag']),
    ...mapGetters('profile', {
      sessionFoundryName: ['sessionFoundryName'],
      sessionFoundryId: ['sessionFoundryId'],
      defaultFoundry: ['defaultFoundry'],
      foundries: ['foundries']
    })
  },
  beforeUnmount () {
    this.$store.commit('profile/clearFoundryData')
  }
}
</script>

<style lang="scss" src="./stylesheets/index.scss" module></style>
